<template>
  <Grid
    class="bg-white-1 full-height"
    gaf="column"
    justify-content="center"
    align-items="center"
    gap="var(--r-space-sm)"
  >
    <RCheckbox v-model="checkbox" :true-value="true" :false-value="false" label="Yes" @input="onInput" />
    <RCheckbox v-model="checkbox" :true-value="false" :false-value="true" label="No" @input="onInput" />
  </Grid>
</template>

<script>
export default {
  name: 'CheckboxEditor',

  data: () => ({
    checkbox: null
  }),

  created() {
    this.checkbox = this.params.value
  },

  methods: {
    getValue() {
      return this.checkbox
    },

    onInput() {
      this.params.api.stopEditing()
    }
  }
}
</script>
